var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cloneElement } from 'react';
import { createPortal } from 'react-dom';
import styled, { keyframes } from 'styled-components';
const ModalBackground = styled.div `
  height: 100vh;
  width: 100vw;
  position:  ${props => props.isPortal ? 'fixed' : 'absolute'};
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
`;
const modalAnimation = keyframes `
 0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const ModalStyle = styled.div `
  opacity: 0;
  height: ${props => props.isFullPage ? '100svh' : props.height};
  min-height: ${props => props.isFullPage ? '100svh' : props.minHeight};
  max-height: ${props => props.isFullPage ? '100svh' : props.maxHeight};
  min-width: ${props => props.isFullPage ? 'auto' : props.minWidth};
  width: ${props => props.isFullPage ? '100svw' : props.width};
  overflow-y: ${props => props.overflowY};
  position:  ${props => props.isPortal ? props.stickPosition ? 'sticky' : 'fixed' : props.stickPosition ? 'sticky' : 'absolute'};
  top: 50%;
  left: 50%;
  transform: ${props => props.stickPosition ? 'translate(0, 0)' : 'translate(-50%, -50%)'};
  background-color: white;
  z-index: 9999;
  padding:  ${props => props.noPadding || props.isFullPage ? '0rem' : '1rem'};
  padding-left: ${props => props.noPadding || props.isFullPage ? '0rem' : '2rem'};
  padding-right: ${props => props.noPadding || props.isFullPage ? '0rem' : '2rem'};
  border-radius: ${props => props.isFullPage ? '0' : props.theme.borders.borderRadius};
  box-shadow: rgba(0, 0, 0, 0.2) 0px 27px 24px 0px;
  animation: ${modalAnimation} 200ms ease-in-out forwards;
  margin-top: ${props => props.isFullPage ? '0' : props.marginTop ? props.marginTop + 'rem' : 0};
  * {
    box-sizing: border-box;
  }
`;
const Modal = (_a) => {
    var { width = 'auto', height = 'auto', minWidth = '50vw', maxHeight = '80vh', minHeight = 'auto', overflowY = 'scroll', marginTop, content, noPadding = false, isPortal = true, stickPosition, stickPositionStyle, open = false, setOpen = () => { }, closeOnClickOutside = true, onClickBackground, isFullPage } = _a, props = __rest(_a, ["width", "height", "minWidth", "maxHeight", "minHeight", "overflowY", "marginTop", "content", "noPadding", "isPortal", "stickPosition", "stickPositionStyle", "open", "setOpen", "closeOnClickOutside", "onClickBackground", "isFullPage"]);
    return isPortal
        ? createPortal(open &&
            _jsx(_Fragment, { children: stickPosition
                    ? _jsxs("div", Object.assign({ style: stickPositionStyle }, { children: [_jsx(ModalBackground, { isPortal: isPortal, onClick: onClickBackground ? () => onClickBackground() : () => setOpen(false) }), _jsx(ModalStyle, Object.assign({ isFullPage: isFullPage, marginTop: marginTop, stickPosition: true, isPortal: isPortal, overflowY: overflowY, width: width, height: height, minHeight: minHeight, maxHeight: maxHeight, noPadding: noPadding, minWidth: minWidth }, props, { children: cloneElement(content, { setOpen, open }) }))] }))
                    : _jsxs(_Fragment, { children: [_jsx(ModalBackground, { isPortal: isPortal, onClick: onClickBackground ? () => onClickBackground() : () => setOpen(false) }), _jsx(ModalStyle, Object.assign({ isFullPage: isFullPage, marginTop: marginTop, isPortal: isPortal, overflowY: overflowY, width: width, height: height, minHeight: minHeight, maxHeight: maxHeight, noPadding: noPadding, minWidth: minWidth }, props, { children: cloneElement(content, { setOpen, open }) }))] }) }), document.getElementById('crono-portal'))
        : open
            ? _jsx(_Fragment, { children: stickPosition
                    ? _jsxs("div", Object.assign({ style: stickPositionStyle }, { children: [_jsx(ModalBackground, { isPortal: isPortal, onClick: onClickBackground ? () => onClickBackground() : () => setOpen(false) }), _jsx(ModalStyle, Object.assign({ marginTop: marginTop, stickPosition: true, isPortal: isPortal, overflowY: overflowY, width: width, height: height, minHeight: minHeight, maxHeight: maxHeight, noPadding: noPadding, minWidth: minWidth }, props, { children: cloneElement(content, { setOpen, open }) }))] }))
                    : _jsxs(_Fragment, { children: [_jsx(ModalBackground, { isPortal: isPortal, onClick: onClickBackground ? () => onClickBackground() : () => setOpen(false) }), _jsx(ModalStyle, Object.assign({ marginTop: marginTop, isPortal: isPortal, overflowY: overflowY, width: width, height: height, minHeight: minHeight, maxHeight: maxHeight, noPadding: noPadding, minWidth: minWidth }, props, { children: cloneElement(content, { setOpen, open }) }))] }) })
            : _jsx(_Fragment, {});
};
export default Modal;
